import Env from 'components/Environments';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';

class Api {
  constructor(csrf, locale) {
    this.csrf = csrf;
    this.locale = locale;
  }

  get(url, options) {
    return this.query('GET', url, options);
  }

  post(url, data) {
    return this.query('POST', url, data);
  }

  query(method, url, data) {
    const urlWithLocale = this.locale && !url.includes(`locale=${this.locale}`) ? `${url}?locale=${this.locale}` : url;
    const queryArgs = this.buildQueryArgs(method, data);

    return fetch(urlWithLocale, queryArgs).then(response => response.json());
  }

  buildQueryArgs(method, data) {
    method = method || 'POST';
    const queryHeaders = new Headers();
    queryHeaders.append('X-CSRF-Token', this.csrf);
    queryHeaders.append('Content-Type', 'application/json');
    queryHeaders.append('Accept', 'application/json');

    const args = {
      method,
      headers: queryHeaders,
      credentials: 'include',
    };
    data = data || {};
    args.signal = data.signal;
    delete data.signal;

    if (Object.keys(data).length) {
      args.body = JSON.stringify(data);
    }

    return args;
  }
}

const api = new Api(Env.getCsrfToken(), Env.getLocale());

export default api;
